<template>
  <button @click="onCopy">
    <transition name="fade" mode="out-in">
      <span v-if="!isCopying" class="copy" key="copy">
        <slot></slot>
      </span>
      <span v-if="isCopying" class="copied" key="copied">Copied!</span>
    </transition>
  </button>
</template>

<script>
const Clipboard = require('clipboard');

export default {
  data() {
    return {
      isCopying: false,
    };
  },
  mounted() {
    const clipboard = new Clipboard(this.$el);

    clipboard.on('success', () => {
      this.isCopying = true;
      setTimeout(() => {
        this.isCopying = false;
      }, 2000);
    });
  },

  methods: {
    onCopy() {
      this.$emit('copy');
    },
  },
};
</script>
